import { CREATE_NEW_USER, CREATE_NEW_USER_SUCCESS, CREATE_NEW_USER_ERROR } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateUser = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_NEW_USER:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_NEW_USER_SUCCESS:
      state = {
        ...state,
        data: action.payload.results,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_NEW_USER_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateUser;
